import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { LoginResponseDataSchema } from "schema"
import { z } from "zod"

export const useLogoutMutation = () => {
  return useMutation({
    mutationFn: async () => {
      const { data } = await axios.post("/auth/logout", {}, { withCredentials: true })
      return data.data as z.infer<typeof LoginResponseDataSchema>
    },
  })
}
